import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CreditmemoService } from 'src/app/services/creditmemo/creditmemo.service';

@Component({
  selector: 'app-creditmemo',
  templateUrl: './creditmemo.component.html',
  styleUrls: ['./creditmemo.component.css']
})
export class CreditmemoComponent implements OnInit {
CreditMemoData:any;
data:any;
  constructor(private router:Router, private  creditMemoService:CreditmemoService) { }

  ngOnInit() {
    this.GetCMHeaderLists()
  }
 getCreditMemoList(){
  this.creditMemoService.getCreditMemoList().subscribe(
    (data)=>{
      this.CreditMemoData=data;
      console.log(this.CreditMemoData);
    }
  )}
  GetCMHeaderLists(){
    this.creditMemoService.GetCMHeaderList().subscribe(
      (data:any) => {
        this.data = data;
        console.log(data);
      }
    )
  }
  viewOrder(id) {
    debugger;
    // alert(id);
    this.router.navigate(['/creditmemolines/' + id + '']);

    // this.engineeringservice.GetPurchaseline(id).subscribe(
    //   data => {
    //     this.data = data;
    //     console.log(data);
    //   })

  }
}
